/*
 * File: InsuranceRecord.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/16/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays one insurance record
 */
import React from "react";
import DateFormatter from "utils/DateFormatter";
import UIListItem from "components/ui/UIListItem";
import InsuranceHeader from "./InsuranceHeader";
import PropTypes from "prop-types";

const InsuranceRecord = ({ insurance }) => {
  return (
    <React.Fragment>
      <InsuranceHeader insurance={insurance} />
      <UIListItem
        label={"Start Date"}
        value={DateFormatter.mdy(insurance.start)}
      />
      <UIListItem label={"End Date"} value={DateFormatter.mdy(insurance.end)} />
      <UIListItem label={"Guarantor"} value={insurance.guarantor} />
      <UIListItem label={"Subscriber ID"} value={insurance.subscriberId} />
      <UIListItem label={"Group ID"} value={insurance.groupId} />
    </React.Fragment>
  );
};

InsuranceRecord.propTypes = {
  insurance: PropTypes.object.isRequired
};

export default InsuranceRecord;
